export default __webpack_public_path__ + "static/media/glisten-logo-wht.f1715c96.svg";